import { render, staticRenderFns } from "./cadestoques.vue?vue&type=template&id=2f495ddd&"
import script from "./cadestoques.vue?vue&type=script&lang=js&"
export * from "./cadestoques.vue?vue&type=script&lang=js&"
import style0 from "./cadestoques.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports